<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Санал хүсэлтүүзд</h4>
        </div>
      
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="categories!=null && categories.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Саналт хүсэлт</th>
                <th>Огноо</th>
                <th>Хэрэглэгч</th>
                <th>Хариу</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(category, index) in categories" v-bind:key="category.id">
                <td>{{index+1}}</td>

                <td>{{category.name}}</td>
                <td>{{category.createdAt | formatDate}}</td>
                <td>
                  <span v-if="category.userData!=null && category.userData!=undefined">
                    {{category.userData.name}}-{{category.userData.phone}}
                  </span>
                  <span v-else>Зочин</span>
                </td>
                <td>
                  <div v-if="category && category.reply!=null && category.reply!=undefined && category.reply!=''" >
                    {{category.reply}}
                  </div>
                  <div v-else>
                    <button @click="showReplyDialog(category)" class="btn btn-primary btn-sm">Хариу бичих</button>
                  </div>
                </td>
             
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="replyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="replyModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="selected">
          <div class="modal-header">
            <h5 class="modal-title" id="alertModalLabel">Санал хүсэлтэд хариулах</h5>
            <br/>
            <p>{{selected.name}}</p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">

              <div class="form-group">
                <label>Дэлгэрэнгүй хариулт</label>
                <textarea
                  rows="5"
                  v-model.trim="replyText"
                  class="form-control"
                  placeholder="Та санал хүсэлтийн хариугаа бичээд хадгална уу"
                  
                />
              </div>

              
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveReply"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >Хадгалах</button>
          </div>
        </div>
      </div>
    </div>



  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
export default {
  name: "FeedBack",
  data() {
    return {
      categories: [],
      selected:null,
      replyText:null

    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this._getObjects();
    // this.set();
    // var now=new Date();
    // var startfulldate = fb.firestore.Timestamp.fromDate(now);
    // fb.db.collectionGroup("selbeg").where("expiredAt", '<=', startfulldate).get().then((docs)=>{

    //        console.log(docs);
        
    // });

    // var startfulldate = fb.firestore.Timestamp.fromDate(now);
    // fb.db.collection("pinnedAd").where("expiredAt", '<=', startfulldate).get().then((docs)=>{
    //     console.log(docs);
    // });
  },
  methods: {

    // async set(){
    //   var docs=await fb.db.collectionGroup("selbeg").where("requestDelete", "==", true).orderBy("createdAt").get();
    //   var batch=fb.db.batch();
    //   for(const itemDoc of docs.docs){
    //     if(itemDoc.exists){
    //       batch.update(
    //         itemDoc.ref,
    //         {
    //           "active": false,
    //           "deleteAt": moment().add(14, 'days').toDate(),
    //           "expiredAt": new Date()
    //         }
    //       )
    //       // console.log(itemDoc.data());
    //       // if(itemDoc.data().category!=null){
    //       //   var category=await itemDoc.data().category.get();
    //       //   if(category.exists){
    //       //     batch.update(
    //       //       itemDoc.ref,
    //       //       {
    //       //         "shortCategory.category": category.data().name
    //       //       }
    //       //     )
    //       //   } 
    //       // }

    //     }
    //   }
    //   await batch.commit();
    //   console.log("DONE");
    // },
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    _getObjects() {
      var _this = this;
      var vm = this;

      fb.db
        .collection("FeedBack").orderBy("createdAt", "desc")
        .get().then(querySnapshot1 => {
          vm.categories = [];
          querySnapshot1.forEach(data => {
            let car = data.data();
            car.id = data.id;
            car.userData=null;
            if(car.userID!=null){
              fb.db.collection('users').doc(car.userID).get().then(userDoc=>{
                if(userDoc!=null && userDoc.exists){
                  car.userData=userDoc.data();
                }
              });
            }
            vm.categories.push(car);
          });
        });


    },
    showReplyDialog(alert){
      this.selected = alert;
      this.replyText=null;
      $("#replyModal").modal("toggle");
    },
    async saveReply(){
      if(this.selected && this.selected.id && this.replyText){
        await fb.db.collection("FeedBack").doc(this.selected.id).update({reply: this.replyText});
        var i=0;
        for(const alert of this.categories){
          if(alert && alert.id && alert.id==this.selected.id){
            alert.reply=this.replyText;
            this.$set(this.categories, i, alert)
            break;
          }
          i++;
        }
        
        $("#replyModal").modal("toggle");
      }
    }
  
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  }
};
</script>